/*
 * Slider do banner principal — ver sections/hero-dual-offer.liquid
 *
 * Sem biblioteca: o trilho anda só com translateX. O que existe aqui é o
 * mínimo para o carrossel não atrapalhar ninguém:
 *
 *  - para de girar quando o mouse entra, quando o teclado entra, e de vez
 *    quando alguém usa as setas, os pontos ou arrasta o dedo;
 *  - nunca gira se a pessoa pediu menos movimento no sistema;
 *  - só o slide visível recebe foco (os outros ficam com tabindex -1), senão
 *    o Tab levaria para um botão fora da tela.
 */

class HeroDualOffer extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hero-track]');
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.timer = null;
    this.parado = false;
    this.intervalo = parseInt(this.dataset.autoplay, 10) || 6000;

    const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.semMovimento = semMovimento.matches;
    semMovimento.addEventListener('change', (e) => {
      this.semMovimento = e.matches;
      if (this.semMovimento) {
        this.pausar();
      } else {
        this.retomar();
      }
    });

    this.ligarControles();
    this.ligarGesto();
    this.mostrar(0);
    this.retomar();
  }

  disconnectedCallback() {
    this.pausar();
  }

  ligarControles() {
    const prev = this.querySelector('[data-hero-prev]');
    const next = this.querySelector('[data-hero-next]');

    if (prev) prev.addEventListener('click', () => this.porInteracao(this.index - 1));
    if (next) next.addEventListener('click', () => this.porInteracao(this.index + 1));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.porInteracao(Number(dot.dataset.heroDot)));
    });

    // Pausa enquanto o mouse ou o foco está dentro; volta quando sai — a não
    // ser que alguém já tenha interagido de verdade.
    this.addEventListener('mouseenter', () => this.pausar());
    this.addEventListener('mouseleave', () => this.retomar());
    this.addEventListener('focusin', () => this.pausar());
    this.addEventListener('focusout', (e) => {
      if (!this.contains(e.relatedTarget)) this.retomar();
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.porInteracao(this.index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.porInteracao(this.index + 1);
      }
    });
  }

  ligarGesto() {
    let x0 = null;

    this.addEventListener(
      'touchstart',
      (e) => {
        x0 = e.touches[0].clientX;
      },
      { passive: true }
    );

    this.addEventListener(
      'touchend',
      (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        this.porInteracao(dx < 0 ? this.index + 1 : this.index - 1);
      },
      { passive: true }
    );
  }

  /* Uma interação explícita desliga o giro automático de vez: quem está
     escolhendo não quer a tela mudando embaixo da mão. */
  porInteracao(destino) {
    this.parado = true;
    this.pausar();
    this.mostrar(destino);
  }

  mostrar(destino) {
    const n = this.slides.length;
    this.index = ((destino % n) + n) % n;
    this.track.style.transform = `translateX(-${this.index * 100}%)`;

    this.slides.forEach((slide, i) => {
      const ativo = i === this.index;
      if (ativo) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
      slide.querySelectorAll('a').forEach((link) => {
        if (ativo) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      });
    });

    this.dots.forEach((dot, i) => {
      if (i === this.index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  pausar() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  retomar() {
    if (this.parado || this.semMovimento || this.timer) return;
    this.timer = setInterval(() => this.mostrar(this.index + 1), this.intervalo);
  }
}

if (!customElements.get('hero-dual-offer')) {
  customElements.define('hero-dual-offer', HeroDualOffer);
}
